import useAsyncTable from "../../hooks/useAsyncTable";
export const useTeamsAndSpaces = () => {
  const {
    data,
    isLoading,
    searchValue,
    fetch,
    isEmptyData,
    updateParam,
    updatePagination,
    pagination,
    
    updateSearchValue,
  } = useAsyncTable<"getSpaces", { name: string }>("getSpaces");

  return {
    loadTeams: fetch,
    updateParam,
    data,
    isLoading,
    searchValue,
    updatePagination,
    updateSearchValue,
    isEmptyData,
    pagination,
  };
};
